import { tableEnUSTranslations } from "../components/table/_lang/en-US";
import { editableFieldEnUSTranslations } from "../controls/editable-field/_lang/en-US";
import { fileEnUSTranslations } from "../controls/file/_lang/en-US";
import { taggedInputEnUSTranslations } from "../controls/tagged-input/_lang/en-US";
import { draftEnUSTranslations } from "../hooks/_lang/en-US";

export const rayaLucariaEnUS = {
  ...tableEnUSTranslations,
  ...draftEnUSTranslations,
  ...editableFieldEnUSTranslations,
  ...fileEnUSTranslations,
  ...taggedInputEnUSTranslations,
  apply: "Apply",
  cancel: "Cancel",
  close: "Close",
  dismiss: "Dismiss",
  saving: "Saving...",
  saved: "Saved",
  clear: "Clear",
  confirm: "Confirm",
  filter: "Filter",
  filterValue: "Filter value",
  expandMenu: "Expand menu",
  collapseMenu: "Collapse menu",
  openMenu: "Open menu",
  mainNavigation: "Main navigation",
  secondaryNavigation: "Secondary navigation",
  navigationMenu: "Navigation menu",
  aboutField: "About {{label}}",
  moreInformation: "More information",
  passcodeLegend: "Enter the {{count}}-character code",
  passcodeCharacter: "Character {{index}} of {{count}}",
  passcodeIncomplete: "Enter all {{count}} characters",
};

export type RayaLucariaTranslationKey = keyof typeof rayaLucariaEnUS;
